export const selectTheme = state => state.theme.darkTheme;
